import type { RouteLocationNormalizedGeneric } from '#vue-router'

export const getNotifyChannelFromUrl = (routeFromParams?: RouteLocationNormalizedGeneric): string | null => {
  const routeFromHook = useRoute()

  const route = routeFromParams || routeFromHook

  if (route) {
    return (route.query?.notify_channel || null) as string | null
  } else {
    return null
  }
}
